import { Dispatch } from "redux";
import { setMessagingTemplateDetails, setMessagingTemplateDetailsLoading } from "@redux/actions/messaging-template-details-actions";
import { getMessagingTemplateRequest } from "@requests/axnadmin-core/get-messaging-template";
import { FormattedMessagingTemplate } from "@idw-types/data/messaging-template";
import { formatMessagingTemplate } from "@formatters/messaging-templates/messaging-template-formatter";
import { logAndDisplayErrorModal } from "@utils/app-alert-util";
import { resources } from "@constants/hardcoded-strings";
import { AxnCompany, AxnRelyingParty } from "@idw-types/data/reference-data/axn";

export const getMessagingTemplateDetailsReduxRequest = (dispatch: Dispatch) => async (
    messagingTemplateId: string,
    axnCompanies: Array<AxnCompany>,
    axnRelyingParties: Array<AxnRelyingParty>
): Promise<FormattedMessagingTemplate> => {
    dispatch(setMessagingTemplateDetailsLoading(true));
    const { data, error } = await getMessagingTemplateRequest(messagingTemplateId);

    if (data) {
        const formattedMessagingTemplate = formatMessagingTemplate(data, axnCompanies, axnRelyingParties);
        dispatch(setMessagingTemplateDetails(formattedMessagingTemplate));
        return formattedMessagingTemplate;
    } else {
        if (error) {
            logAndDisplayErrorModal(
                dispatch,
                error,
                resources.requests.getMessagingTemplateDetails.error.title,
                resources.requests.getMessagingTemplateDetails.error.message
            );
        }
        dispatch(setMessagingTemplateDetailsLoading(false));
        return null;
    }
};